export default () => {
    // self.addEventListener('message', (event) => {
       
    //     // return false if event not present
    //     if (!event) {
    //         return false;
    //     }       
    //     postMessage("done");
    // })
}



// function abc() {
//     self.addEventListener('message', (event) => {
//         // return false if event not present
//         if (!event) {
//             return false;
//         }
//         const { adApiDataRes, locationId, gptAdId } = event.data;
//         // worker proccess
//         adRenderLogicWW(adApiDataRes, locationId, gptAdId);
//     })
// }

// export { abc };
